













export default {
  name: 'AudioPlayerBtn',
  props: {
    src: { type: String, required: true },
    text: { type: String, default: 'Play' }
  },
  data(): any {
    return {
      audio: null as HTMLAudioElement | null,
      isPlaying: false
    };
  },
  watch: {
    src(): void {
      if (this.audio && this.isPlaying) {
        this.stopAudio();
      }
      this.createAudioElement();
    }
  },
  methods: {
    createAudioElement(): void {
      if (this.audio) {
        this.audio.removeEventListener('ended', this.onEnded);
        this.audio.pause();
      }
      this.audio = new Audio(this.src);
      this.audio.addEventListener('ended', this.onEnded);
    },
    togglePlay(): void {
      if (!this.audio) {
        this.createAudioElement();
      }

      if (this.isPlaying) {
        this.stopAudio();
      } else {
        this.playAudio();
      }
    },
    playAudio(): void {
      this.audio.currentTime = 0;
      this.audio
        .play()
        .then(() => (this.isPlaying = true))
        .catch((err) => console.error('Audio play failed:', err));
    },
    stopAudio(): void {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.isPlaying = false;
    },
    onEnded(): void {
      this.isPlaying = false;
    }
  },
  beforeDestroy(): void {
    if (this.audio) {
      this.audio.removeEventListener('ended', this.onEnded);
      this.audio.pause();
      this.audio = null;
    }
  }
};
